import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UserState } from "./users";
import { addUserFunc, getUsersFunc, addServiceUserFunc } from "@/services/firebase/user-functions";
import { AddUserArgs, AddServiceUserArgs } from "common247";

//TODO:JJ - Aaaarrgg - is there a better way to get a global instance of the Firebase Setup!?! Check out store slices etc!
import { getGlobalFirebase } from "@services/globals";
import { AppUserModel } from "common247";

const initialState: UserState = {
  users: [],
  timestamp: Date.now(),
  status: "idle",
  error: undefined,
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload as AppUserModel[];
        state.timestamp = Date.now();
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("fetchUser.rejected", state, action);
      })

      .addCase(addUser.fulfilled, (state, action) => {
        const user: AppUserModel = action.payload as AppUserModel;
        state.users.push(user);
      })
      .addCase(addUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("addUser.rejected", state, action);
      })
      .addCase(addServiceUser.fulfilled, (state, action) => {
        const user: AppUserModel = action.payload as AppUserModel;
        state.users.push(user);
      })
      .addCase(addServiceUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("addServiceUser.rejected", state, action);
      });
  },
});

export const fetchUsers = createAsyncThunk("user/fetchUsers", async () => {
  console.log("STORE - fetchUsers");
  const fb = getGlobalFirebase();
  return await getUsersFunc(fb);
});

export const addUser = createAsyncThunk("user/addUser", async (args: AddUserArgs) => {
  console.log("STORE - addUser", args);
  const fb = getGlobalFirebase();
  return await addUserFunc(fb, args);
});

export const addServiceUser = createAsyncThunk("user/addServiceUser", async (args: AddServiceUserArgs) => {
  console.log("STORE - addServiceUser", args);
  const fb = getGlobalFirebase();
  return await addServiceUserFunc(fb, args);
});

// Action creators are generated for each case reducer function

export const {} = userSlice.actions;

export default userSlice.reducer;
